import { render, staticRenderFns } from "./regiest.vue?vue&type=template&id=dd68ed3c&scoped=true&"
import script from "./regiest.vue?vue&type=script&lang=js&"
export * from "./regiest.vue?vue&type=script&lang=js&"
import style0 from "./regiest.vue?vue&type=style&index=0&id=dd68ed3c&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd68ed3c",
  null
  
)

export default component.exports